import React, { Component } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import Footer from './Footer';
import { ensureDashliteStyles, setDashliteBodyClass, DASHLITE_BODY_CLASS } from '../../utils/dashlite';
import './layout.css';

class DashliteLayout extends Component {
  state = { mobileSidebar: false };

  componentDidMount() {
    ensureDashliteStyles();
    setDashliteBodyClass(DASHLITE_BODY_CLASS);
  }

  componentWillUnmount() {
    document.body.className = '';
  }

  toggleMobileSidebar = () => {
    this.setState((prev) => {
      const mobileSidebar = !prev.mobileSidebar;
      document.body.classList.toggle('nav-shown', mobileSidebar);
      return { mobileSidebar };
    });
  };

  render() {
    return (
      <div className="nk-app-root">
        <div className="nk-main">
          <Sidebar onToggleMobile={this.toggleMobileSidebar} />
          <div className="nk-wrap">
            <Header onToggleMobile={this.toggleMobileSidebar} />
            <div className="nk-content">
              <div className="container-fluid">
                <div className="nk-content-inner">
                  <div className="nk-content-body">
                    {this.props.children}
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    );
  }
}

export default DashliteLayout;
